import {ValueObject} from '@s-ui/domain'

export class BodyTypeValueObject extends ValueObject {
  /**
   * @param {Object} params
   * @param {String} params.bodyType
   * @param {Number} params.doors
   * @param {String} params.url
   * @param {Bool} params.isSelected
   * */
}
